<script lang="ts">
	import { isFilled } from '@prismicio/client';
	import { PrismicImage, PrismicRichText } from '@prismicio/svelte';
	import Wordmark from './Wordmark.svelte';
	import PlayerStats from './PlayerStats.svelte';

	const { player } = $props();
	const playerId = player.data.id;
</script>

{#key playerId}
	<article class="player-card">
		<div class="player-card__image--container">
			<div class="player-card__image--background" class:has-headshot={isFilled.image(player.data.image)}>
				<Wordmark />
			</div>

			{#if isFilled.image(player.data.image)}
				<PrismicImage field={player.data.image} class="player-card__image" loading="lazy" />
			{/if}

			{#if isFilled.number(player.data.number)}
				<div class="player-card__number">{player.data.number}</div>
			{/if}

			{#if player.data.captain}
				<div class="player-card__letter">C</div>
			{/if}

			{#if player.data.assistant_captain}
				<div class="player-card__letter">A</div>
			{/if}

			{#if player.data.position !== 'Netminder'}
				<PlayerStats season={player.data.season} allTime={player.data.all_time} />
			{/if}
		</div>

		<div class="player-card__content">
			{#if isFilled.select(player.data.position)}
				<div class="player-card__content--position">
					{player.data.position}
				</div>
			{/if}

			{#if isFilled.richText(player.data.name)}
				<div class="player-card__content--title">
					<PrismicRichText field={player.data.name} />
				</div>
			{/if}
		</div>
	</article>
{/key}
